import React from "react";
import { FaHammer, FaBuilding } from "react-icons/fa";
import "../css/Register.css";
import { Button, Link, Typography } from "@mui/material";
import logo from "../image/ClearVault_logo.png";
import { useNavigate } from "react-router";

function Register() {
  const navigate = useNavigate();
  return (
    <div
      className="register-page text-center py-2 d-flex flex-column justify-content-between"
      style={{ minHeight: "100vh" }}
    >
      {/* Header Section */}
      <div className="mb-5 mt-3">
        <img src={logo} className="logo mb-2" alt="ClearVault Logo" />
        <Typography variant="h6" className="register-subtitle text-muted">
          Choose your role to get started with AI-powered construction project
          management
        </Typography>
      </div>

      {/* Role Cards */}
      <div className="register-container d-flex flex-column align-items-center flex-grow-1">
        <div
          className="row g-2 justify-content-center w-100"
          style={{ maxWidth: "900px" }}
        >
          {/* Contractor Card */}
          <div className="col-md-6 col-12 d-flex justify-content-center">
            <div className="role-card contractor-card p-4 shadow-sm">
              <div className="w-100 d-flex justify-content-center">
                <div className="icon-box contractor-icon mb-3">
                  <FaHammer size={26} />
                </div>
              </div>
              <h3 className="fw-bold text-center" style={{ fontSize: "18px" }}>
                Contractor
              </h3>
              <p className="text-muted text-center">
                A skilled licensed professional entrusted with the authority and
                responsibility to oversee, manage, and deliver civil
                construction projects as per client requirements and legal
                standards.
              </p>

              <button
                className="btn get-started-btn contractor-btn mt-4"
                onClick={() =>
                  navigate("/register-form", {
                    state: { userType: "Contractor" },
                  })
                }
              >
                Choose
              </button>
            </div>
          </div>

          {/* Project Owner Card */}
          <div className="col-md-6 col-12 d-flex justify-content-center">
            <div className="role-card owner-card p-4 shadow-sm">
              <div className="w-100 d-flex justify-content-center">
                <div className="icon-box owner-icon mb-3">
                  <FaBuilding size={16} />
                </div>
              </div>
              <h3 className="fw-bold text-center" style={{ fontSize: "18px" }}>
                Owner/Project Owner
              </h3>
              <p className="text-muted text-center">
                The primary stakeholder who initiates, finances, and oversees
                the entire building or plant construction project, holding
                ultimate responsibility for its vision and success
              </p>
              <button
                className="btn get-started-btn owner-btn mt-4"
                onClick={() =>
                  navigate("/register-form", {
                    state: { userType: "Project Owner" },
                  })
                }
              >
                Choose
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Back to Login Button (Bottom Section) */}
      <div className="text-center mb-4">
        <Typography
                  variant="body2"
                  sx={{
                    mt: 2,
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Already have an account?{" "}
                  <Link
                    href="/login"
                    underline="none"
                    color="primary"
                    className="ms-1"
                  >
                    Login
                  </Link>
                </Typography>
      </div>
    </div>
  );
}

export default Register;
